import { useIsArtefactEditable } from '@modules/common/hooks';
import { trackDashboardEvent } from '@modules/dashboard/helpers';
import { useUpdateDashboard } from '@modules/dashboard/hooks/useUpdateDashboard';
import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { LoadingButton } from '@mui/lab';
import { Stack } from '@mui/material';
import { Status } from 'generated/graphql';

export const UnarchiveDashboardButton = () => {
  const dashboard = useDashboardStore(({ dashboard }) => dashboard);

  const { updateDashboard, loading } = useUpdateDashboard();

  const isEditable = useIsArtefactEditable({
    editToken: dashboard.editToken,
    status: dashboard.status,
  });

  if (!dashboard || !isEditable) {
    return null;
  }

  const onClick = async () => {
    await updateDashboard({
      updateRequest: {
        id: dashboard?.id ?? '',
        viewToken: dashboard?.viewToken ?? '',
        editToken: dashboard?.editToken ?? '',
        status: Status.Unarchived,
      },
    });
    trackDashboardEvent({
      eventName: 'Dashboard Archived',
      dashboardLink: window.location.href,
    });
  };

  return (
    <Stack justifyContent="center">
      <LoadingButton
        variant="contained"
        loading={loading}
        onClick={onClick}
        color="primary"
      >
        Unarchive
      </LoadingButton>
    </Stack>
  );
};
